import { React, useEffect, useState, useRef } from 'react'
import { Toast } from 'primereact/toast';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import axios from 'axios';
import './CustomerPortal.css';
import UseCustomFormik from './formik';
import deepDiff, { diff } from 'deep-diff';
import UserDetails from './Sectors/UserDetails';
import CustomerServiceMenu from './Sectors/CustomerServiceMenu';
import Nominees from './Sectors/Nominees';
import Assignees from './Sectors/Assignees';
import Guardian from './Sectors/Guardian';

import NameChange from './Sectors/NameChange';
import AddressChange from './Sectors/AddressChange';
import NicChange from './Sectors/NicChange';
import BackEndUrl from '../backURL';
import ContactChange from './Sectors/ContactChange';
import { Requests } from './Sectors/Requests';
import { w3cwebsocket as W3CWebSocket } from "websocket";
const backend_ = BackEndUrl.domain;
const modified_backend_Url = backend_.replace(/^https:\/\//, '');
const client = new W3CWebSocket('wss://'+modified_backend_Url);
client.onopen = () => {};



const backend = BackEndUrl.domain
const CustomerServicing = ({ data, policy_number, tab }) => {
    const [selected_service, setSelectedService] = useState([0])
    const [req_count, SetReqCount] = useState(null)
    const formik = UseCustomFormik(selected_service, data, policy_number); //passing the data for validation
    const selectedData = data && data.find(value => value.policy_number == policy_number); //selected the data related to the specific policy of the user
    const [percentageValid, setPercentageValid] = useState(true);
    const [isReqLoading, SetReqLoading] = useState(false);


    //check if there are  any pending requests  from the user
    async function is_a_req_pending() {
        const selectedData = data && data.find(value => value.policy_number == policy_number);
        const response = await axios.post(backend + "/check-pending-reqs", {
            policy_number: policy_number,
            user_id: selectedData.user_id,
        }, {
            headers: {
                Authorization: sessionStorage.getItem('token'),
            }
        })
        return response.data[0] && response.data[0].req_count
    }
    useEffect(() => {
        async function setReqpend() {
            SetReqCount(await is_a_req_pending())
            SetReqLoading(false)

        }
        setReqpend();


    }, []);

    const toast = useRef(null);
    // Onclick on the Request button

    async function alerationReq(reqType, table, policy_number) {
        function checkIfAllNull(array) {
            for (let i = 0; i < array.length; i++) {
                const proofDoc = array[i]


            }

            return false;
        }

        formik.validateForm().then(async (errors) => {




            if (Object.keys(errors).length === 0 || (Object.keys(errors[table]).length == 1 && !Array.isArray(formik.errors[table]) && formik.errors[table]?.proof_doc.every(obj => Object.keys(obj).length === 0))) {


                if (percentageValid == true || table != "nominee") {
                    SetReqLoading(true)
                    // check whether new data is added 
                    //eg : new nominee,new assignee etc..
                    const Newly_Added_Data = formik.values && formik.values[table].filter((item, index) => {

                        return selectedData[table][index] === undefined;

                    });
                    // get the data which is from the input feilds that was previously added  
                    //eg: value of the input feilds of the previously added nominee etc..
                    const Newly_Altenated_Data = formik.values && formik.values[table].filter((item, index) => {

                        return selectedData[table][index] != undefined;

                    });
                    //

                    function FindProofDoc(table, index, table_id) {
                        return formik.values[table][index].proof_doc?.filter((item) => {

                            return item.id == table_id
                        })
                    }


                    if (Newly_Added_Data.length > 0) {
                        for (const val of Newly_Added_Data) {
                            const formData = new FormData();
                            formData.append("policy_number", policy_number);
                            formData.append("user_id", selectedData.user_id);
                            formData.append("table", table);
                            formData.append("type", reqType);
                            formData.append('name', val.name);
                            formData.append('mobile', sessionStorage.getItem('mobile'));
                            formData.append('nic', val.nic);
                            formData.append('holder_nic', sessionStorage.getItem('nic'));
                            formData.append('relationship', val.relationship);
                            formData.append('birthday', val.birthday);
                            formData.append('percentage', val.percentage || "");

                            for (const item of val.proof_doc) {

                                if (item.file instanceof File || item.file instanceof Blob) {
                                    formData.append('files', item.file);
                                } else {
                                    console.warn('Invalid file:', item.file);
                                }


                            }

                            try {
                                const response = await axios.post(backend + "/adding_data_req", formData, {
                                    headers: {
                                        Authorization: sessionStorage.getItem('token'),
                                    }
                                });
                                client.send(JSON.stringify({
                                    type: "message",
                                    msg: "status changed",

                                }));


                            } catch (error) {
                                console.error('Error:', error.message);
                            }
                        }
                        SetReqCount(await is_a_req_pending());
                    }

                    const findDifferences = (oldData, newData) => deepDiff(oldData, newData);
                    var userIndexs = [];

                    const differences = findDifferences(selectedData[table], Newly_Altenated_Data);// checking for altenations done in the data of nominee ,asignee etc...      
                    differences && differences.forEach(async function (diff) {

                        const index = diff.path[0];
                        const userId = selectedData[table][index]?.id;

                        const userExists = userIndexs.some(item => item.table_id === userId && item.index === index);

                        if (!userExists) {
                            const userObj = {
                                table_id: userId,
                                index: index
                            }
                            userIndexs.push(userObj);
                        }

                    })

              

                    userIndexs?.forEach(async function (val) {          
                      
                            const filteredDiffs= differences.filter((item)=>{

                                return selectedData[table][item.path[0]]?.id == val.table_id && item.path[1] != "proof_doc"

                            })                


                             const formData = new FormData();
                            const proofDoc = FindProofDoc(table, val.index, val.table_id);
                            formData.append('table_name', table);
                            formData.append('differences[]',JSON.stringify(filteredDiffs));
                            formData.append('user_id', selectedData.user_id);
                            formData.append('policy_number', policy_number);
                            formData.append('mobile', sessionStorage.getItem('mobile'));
                            formData.append('nic', sessionStorage.getItem('nic'));
                            formData.append('table_id', val.table_id);                  


                            if (proofDoc) {
                                for (const item of proofDoc) {

                                    if (item.file instanceof File || item.file instanceof Blob) {
                                        formData.append('files', item.file);
                                    } else {
                                        console.warn('Invalid file:', item.file);
                                    }


                                }
                            }

                            const response = await axios.post(backend + "/alteration-details", formData, {
                                headers: {
                                    Authorization: sessionStorage.getItem('token'),
                                }

                            }

                                , async (err) => {


                                    SetReqCount(await is_a_req_pending());
                                });
                                
                 
                    SetReqCount(await is_a_req_pending());
                    client.send(JSON.stringify({
                        type: "message",
                        msg: "status changed",

                    }));
                            




                        
                    })





                    SetReqCount(await is_a_req_pending());

                    client.send(JSON.stringify({
                        type: "message",
                        msg: "status changed",

                    }));
                    
                }
                else {

                    toast.current.clear();
                    toast.current.show({
                        severity: 'error',
                        summary: 'The Sum of Provided Percentages Should be 100',

                        life: 3000,
                        sticky: false,
                        content: (props) => (
                            <div className="p-3" style={{ flex: '1' }}>
                                <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                                <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                            </div>
                        ),
                    });
                }

            }
            else {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'Invalid Inputs',
                    description: "Please Enter valid information"
                    ,
                    life: 3000,
                    sticky: false,
                    content: (props) => (
                        <div className="p-3" style={{ flex: '1' }}>
                            <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                            <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                        </div>
                    ),
                });
            }
        });

    }
    //Onclick on the Request button in User Detais Menu
    async function UserDetailAlt(field) {

        formik.validateForm().then(async (errors) => {

            if (Object.keys(errors).length === 0 || !Object.keys(errors).includes(field)) {

                if (field == "policy_fullname") {
                    if (formik.values[field]) {
                        const formData = new FormData();
                        const proofDoc = formik.values.policy_proofdoc
                        if (proofDoc) {


                            formData.append('table_name', "policy_details");
                            formData.append('field', 'Policy Full Name ');
                            formData.append('old_value', selectedData[field])
                            formData.append('new_value', formik.values[field]);
                            formData.append('req_prof_desc', formik.values['proof_description']);
                            formData.append('user_id', selectedData.user_id);
                            formData.append('mobile', sessionStorage.getItem('mobile'));
                            formData.append('policy_number', policy_number);
                            if (proofDoc) {
                                for (const item of proofDoc) {


                                    if (item instanceof File || item instanceof Blob) {
                                        formData.append('files', item);
                                    } else {
                                        console.warn('Invalid file:', item);
                                    }


                                }
                            }
                            const response = await axios.post(backend + "/policy_alternation_req", formData, {
                                headers: {
                                    Authorization: sessionStorage.getItem('token'),
                                }
                            });
                            
                            client.send(JSON.stringify({
                                type: "message",
                                msg: "status changed",

                            }));

                            SetReqCount(await is_a_req_pending());
                        }
                    }
                }

                if (field == "policy_address") {

                    const formData = new FormData();
                    const proofDoc = formik.values.policy_proofdoc
                    const newAddress = `${formik.values.policy_address1},${formik.values.policy_address2},${formik.values.policy_address3},${formik.values.policy_address4}`
                    const oldAddress = `${selectedData.policy_address1},${selectedData.policy_address2},${selectedData.policy_address3},${selectedData.policy_address4}`
                    if (proofDoc) {
                        formData.append('files', proofDoc);
                        formData.append('table_name', "policy_details");
                        formData.append('field', 'Policy Address ');
                        formData.append('old_value', oldAddress)
                        formData.append('new_value', newAddress);
                        formData.append('req_prof_desc', formik.values['proof_description']);
                        formData.append('user_id', selectedData.user_id);
                        formData.append('mobile', sessionStorage.getItem('mobile'));
                        formData.append('policy_number', policy_number);
                        if (proofDoc) {
                            for (const item of proofDoc) {


                                if (item instanceof File || item instanceof Blob) {
                                    formData.append('files', item);
                                } else {
                                    console.warn('Invalid file:', item);
                                }


                            }
                        }
                        const response = await axios.post(backend + "/policy_alternation_req", formData, {
                            headers: {
                                Authorization: sessionStorage.getItem('token'),
                            }
                        });
                        client.send(JSON.stringify({
                            type: "message",
                            msg: "status changed",

                        }));
                        SetReqCount(await is_a_req_pending());
                    }

                }
                if (field == "policy_nic") {
                    if (formik.values[field]) {
                        const formData = new FormData();
                        const proofDoc = formik.values.policy_proofdoc
                        if (proofDoc) {

                            formData.append('files', proofDoc);
                            formData.append('table_name', "policy_details");
                            formData.append('field', 'Policy NIC ');
                            formData.append('old_value', selectedData[field])
                            formData.append('new_value', formik.values[field]);
                            formData.append('req_prof_desc', formik.values['proof_description']);
                            formData.append('mobile', sessionStorage.getItem('mobile'));
                            formData.append('user_id', selectedData.user_id);
                            formData.append('policy_number', policy_number);
                            if (proofDoc) {
                                for (const item of proofDoc) {


                                    if (item instanceof File || item instanceof Blob) {
                                        formData.append('files', item);
                                    } else {
                                        console.warn('Invalid file:', item);
                                    }


                                }
                            }
                            const response = await axios.post(backend + "/policy_alternation_req", formData, {
                                headers: {
                                    Authorization: sessionStorage.getItem('token'),
                                }
                            });
                            client.send(JSON.stringify({
                                type: "message",
                                msg: "status changed",

                            }));
                            SetReqCount(await is_a_req_pending());
                        }
                    }
                }
                if (field == "policy_mobile") {

                    if (formik.values[field]) {

                        const formData = new FormData();

                        formData.append('files', null);
                        formData.append('table_name', "policy_details");
                        formData.append('field', 'Contact Number ');
                        formData.append('old_value', formik.values[field].oldMobile)
                        formData.append('new_value', formik.values[field].newMobile);
                        formData.append('req_prof_desc', formik.values['proof_description']);
                        formData.append('user_id', selectedData.user_id);
                        formData.append('mobile', sessionStorage.getItem('mobile'));
                        formData.append('policy_number', policy_number);
                        const response = await axios.post(backend + "/policy_alternation_req", formData, {
                            headers: {
                                Authorization: sessionStorage.getItem('token'),
                            }
                        })
                        client.send(JSON.stringify({
                            type: "message",
                            msg: "status changed",

                        }));

                        SetReqCount(await is_a_req_pending());

                    }
                }
            } else {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'Invalid Information',

                    life: 3000,
                    sticky: false,
                    content: (props) => (
                        <div className="p-3" style={{ flex: '1' }}>
                            <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                            <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                        </div>
                    ),
                });
            }
        });

    }





    //check if to make the proof documents are required or not
    function CheckProofDocRequired(table, nameoffile, index) {
        if (
            selectedData[table] &&
            selectedData[table].length >= index + 1 &&
            selectedData[table][index] &&
            selectedData[table][index][nameoffile] !== formik.values[table]?.[index]?.[nameoffile]
        ) {
            const isFilePresent = formik.values[table]?.[index]?.proof_doc?.find((item) => item?.name === nameoffile);

            if (!isFilePresent) {
                formik.errors[table] = formik.errors[table] || {};
                formik.errors[table].proof_doc = formik.errors[table].proof_doc || [];
                formik.errors[table].proof_doc[index] = {
                    ...(formik.errors[table]?.proof_doc?.[index] || {}),
                    [nameoffile]: "*Required",
                };
            } else {
                if (formik.errors[table]?.proof_doc?.[index]?.[nameoffile]) {
                    delete formik.errors[table].proof_doc[index][nameoffile];
                    if (Object.keys(formik.errors[table].proof_doc[index]).length === 0) {
                        delete formik.errors[table].proof_doc[index];
                    }
                }
            }
        } else {
            if (selectedData?.[table].length < index + 1) {
                formik.errors[table] = formik.errors[table] || {};
                formik.errors[table].proof_doc = formik.errors[table].proof_doc || [];
                formik.errors[table].proof_doc[index] = formik.errors[table].proof_doc[index] || {};
                if (formik.values[table]?.[index]?.proof_doc?.length === 0) {
                    formik.errors[table].proof_doc[index] = {
                        new: "Required",
                    };
                } else {
                    if (formik.errors[table]?.proof_doc?.[index]?.new) {
                        delete formik.errors[table].proof_doc[index].new;
                    }
                }
            }
        }
    }

    // Check whether the sum of the percentage of each nominee is equal to 100
    function CheckPercentageValid() {

        var sum_of_percentage = 0;

        formik.values.nominee?.map((value) => {
            sum_of_percentage += value.percentage || 0;
        });

        if (sum_of_percentage == 100) {
            setPercentageValid(true);
        } else {
            setPercentageValid(false);
        }
    }
    if (sessionStorage.getItem('logged') && sessionStorage.getItem('logged') == 'ture') {
        return (
            <Row className='d-flex justify-content-center mt-1 ' >

                <Col lg={11} sm={12} xs={12} md={12} className='d-flex justify-content-center align-items-center flex-column'>
                    <Toast ref={toast} position="top-center" />
                    {selected_service == 0 ?
                        <CustomerServiceMenu setSelectedService={setSelectedService} />
                        : null}
                    {
                        selected_service == "1" ?
                            <UserDetails formik={formik} setSelectedService={setSelectedService} selectedData={selectedData} req_count={req_count} UserDetailAlt={UserDetailAlt} policy_number={policy_number} />

                            : null
                    }
                    {
                        selected_service == "2" ?

                            <Nominees
                                formik={formik}
                                setSelectedService={setSelectedService}
                                selectedData={selectedData}
                                CheckProofDocRequired={CheckProofDocRequired}
                                CheckPercentageValid={CheckPercentageValid}
                                req_count={req_count}
                                alerationReq={alerationReq}
                                policy_number={policy_number}
                                isReqLoading={isReqLoading}



                            /> :
                            null
                    }
                    {
                        selected_service == "3" ?
                            <Assignees
                                formik={formik}
                                setSelectedService={setSelectedService}
                                selectedData={selectedData}
                                CheckProofDocRequired={CheckProofDocRequired}
                                req_count={req_count}
                                alerationReq={alerationReq}
                                policy_number={policy_number}
                                isReqLoading={isReqLoading}

                            />
                            :
                            null


                    }
                    {
                        selected_service == "4" ?


                            <Guardian
                                formik={formik}
                                setSelectedService={setSelectedService}
                                selectedData={selectedData}
                                CheckProofDocRequired={CheckProofDocRequired}
                                req_count={req_count}
                                alerationReq={alerationReq}
                                policy_number={policy_number}
                                isReqLoading={isReqLoading}

                            />
                            :
                            null


                    }

                    {
                        selected_service == "6" ?

                            <Requests policy_number={policy_number} setSelectedService={setSelectedService} /> : null
                    }

                </Col>
                <Col xs={9} className='d-flex justify-content-center'>


                </Col>





            </Row>

        )
    } else {


        window.location.href = '/customer-portal/login';


    }
}

export default CustomerServicing
